/** @format */

import { FunctionComponent as FC } from 'react';
import { P } from '../ui/Typography';

import styled from 'styled-components';
import { breakpointFrom, breakpointUpTo } from '../../theme/mixins';
import { Route } from '../../types/shared';
import { StyledButton } from '../ui/Button';

export const ListButtonRouting: FC<Props> = ({ route }) => {
  const { label, link } = route.fields;

  return (
    <Wrapper>
      <Title as="h4">{label.toLowerCase()}</Title>
      <StyledButton href={link.fields.slug} position="right" variant="secondaryWhite" elementType="inbound">
        {''}
      </StyledButton>
    </Wrapper>
  );
};

type Props = {
  route: Route;
};

const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1.5px solid ${({ theme }) => theme.color.white};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 1.5rem 0;
  margin-top: 0 !important;

  h4,
  span:first-of-type {
    grid-column: 1/-1;
  }

  ${breakpointUpTo.sm`
    span {
      grid-column: 1/-1;
    }

    a {
      justify-self: start;
    }
  `}

  ${breakpointFrom.xl`
      gap: 0.6rem;

    h4,
    span:first-of-type {
      grid-column: auto;
    }

    a, span {
      justify-self: end;
    }

    & > * + * {
      margin-top: 0;
    }

  `}
`;

const Title = styled(P)`
  font-weight: 500;
  color: ${({ theme }) => theme.color.white};
  text-transform: capitalize;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;
